import React from 'react';
import { UserShape } from '../types';

export const useUserContext = () => {
    const value = React.useContext(UserContext);
    return value;
};

export const UserContext = React.createContext<Partial<{ user: UserShape | undefined }>>({});

interface UserProviderProps {
    user?: UserShape;
    children?: React.ReactNode;
}

export const UserProvider: React.FunctionComponent<UserProviderProps> = (props) => {
    return (
        <UserContext.Provider value={{ user: props.user }}>{props.children}</UserContext.Provider>
    );
};

export default UserProvider;
